import React from "react";
import { ItemCard } from "../";

const Item = ({ data }) => {
  return <ItemCard item={data} />;
};

export default Item;
